import { Search } from "../../api/searchService";
import { isFailedResponse } from "../../api/request";

/**
 * Adds or removes the given contacts through the search endpoint's marketing list
 * action, restricted to those contacts. Resolves true once the service has done it.
 */
async function changeMembership(
  globalDispatch: unknown,
  message: string,
  listId: string,
  contactIds: string[],
  remove: boolean
) {
  const response = await Search(globalDispatch, message, {
    AdvancedSearchJoins: [],
    AdvancedSearchNodes: [],
    EntityName: "contact",
    Fields: [{ Label: "Name", Name: "name" }],
    Filters: {},
    IsAdvancedSearch: true,
    IsExport: undefined,
    PageRequested: undefined,
    PageSize: undefined,
    ReplaceExistingListMembers: undefined,
    MarketingListName: undefined,
    MarketingListId: listId,
    RemoveFromMarketingList: remove,
    // Search's JS default is null, which TypeScript takes as the only type allowed.
    SelectedRecordIds: contactIds as unknown as null,
  });

  return !isFailedResponse(response);
}

export const addContactsToList = (
  globalDispatch: unknown,
  listId: string,
  contactIds: string[]
) =>
  changeMembership(
    globalDispatch,
    "Contacts added to the list",
    listId,
    contactIds,
    false
  );

export const removeContactsFromList = (
  globalDispatch: unknown,
  listId: string,
  contactIds: string[]
) =>
  changeMembership(
    globalDispatch,
    "Members removed from the list",
    listId,
    contactIds,
    true
  );
